module.exports = __webpack_public_path__ + "img/logo.f916af73.png";